import React from 'react';

const NamePlaceholderImage: React.FC<{ name: string }> = ({ name }) => {
  return (
    <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center bg-primary rounded-full">
      <span className="text-white text-xl">{name.substring(0, 1)}</span>
    </div>
  );
};

export default NamePlaceholderImage;
